import { BarTask } from '@interfaces/ganttTasks/barTask';
import { Task } from '@interfaces/ganttTasks/ganttTasks';

import { EGanttTaskType } from '@enums/ganttTasks';

export const convertToBarTasks = (
	tasks: Task[],
	dates: Date[],
	columnWidth: number,
	rowHeight: number,
	taskHeight: number,
	barCornerRadius: number,
	handleWidth: number,
) => {
	const barTasks = tasks.map((t, i) =>
		convertToBarTask(
			t,
			i,
			dates,
			columnWidth,
			rowHeight,
			taskHeight,
			barCornerRadius,
			handleWidth,
		),
	);

	for (let i = 0; i < barTasks.length; i++) {
		const barTask = barTasks[i];

		if (!barTask.dependencies) continue;

		for (let j = 0; j < barTask.dependencies.length; j++) {
			const {
				id: depId,
				type: linkType,
				isActive,
			} = barTask.dependencies[j];

			const dependentTask = barTasks.find(task => task.id === depId);
			if (dependentTask) {
				dependentTask.barLinkedChildren.push({
					linkedBar: barTask,
					linkType,
					isActive,
				});
			}
		}
	}

	return barTasks;
};

export const getTaskXCoordinate = (xDate: Date, dates: Date[], columnWidth: number) => {
	const index = dates.findIndex(d => d.getTime() >= xDate.getTime()) - 1;

	const remainderMillis = xDate.getTime() - dates[index].getTime();

	const percentOfInterval = remainderMillis / (dates[index + 1].getTime() - dates[index].getTime());

	return index * columnWidth + percentOfInterval * columnWidth;
};

export const getTaskYCoordinate = (
	index: number,
	rowHeight: number,
	taskHeight: number,
) => {
	return index * rowHeight + (rowHeight - taskHeight) / 2;
};

const convertToBar = (
	task: Task,
	index: number,
	dates: Date[],
	columnWidth: number,
	rowHeight: number,
	taskHeight: number,
	barCornerRadius: number,
	handleWidth: number,
): BarTask => {
	const x1 = getTaskXCoordinate(task.start, dates, columnWidth);
	let x2 = getTaskXCoordinate(task.end, dates, columnWidth);

	if (task.type === 'task' && x2 - x1 < handleWidth * 2) {
		x2 = x1 + handleWidth * 2;
	}

	const y = getTaskYCoordinate(index, rowHeight, taskHeight);
	const hideChildren = task.type === EGanttTaskType.milestone ? task.hideChildren : undefined;

	return {
		...task,
		x1,
		x2,
		y,
		index,
		barCornerRadius,
		handleWidth,
		hideChildren,
		height: taskHeight,
		barLinkedChildren: [],
	};
};

const convertToBarTask = (
	task: Task,
	index: number,
	dates: Date[],
	columnWidth: number,
	rowHeight: number,
	taskHeight: number,
	barCornerRadius: number,
	handleWidth: number,
): BarTask => {
	let barTask: BarTask;

	switch (task.type) {
		case EGanttTaskType.milestone:
			barTask = convertToBar(
				task,
				index,
				dates,
				columnWidth,
				rowHeight,
				taskHeight,
				barCornerRadius,
				handleWidth,
			);
			break;
		default:
			barTask = convertToBar(
				task,
				index,
				dates,
				columnWidth,
				rowHeight,
				taskHeight,
				barCornerRadius,
				handleWidth,
			);
			break;
	}

	return barTask;
};
